module.exports = __webpack_public_path__ + "img/integrations-google.6654c95e.png";